export default import.meta.ROLLDOWN_FILE_URL_U2YZxvNlcnuoWcGKwa9Wsw